export interface TouristSpot {
  id: string;
  slug: string;
  name: string;
  districtSlug: string;
  districtName: string;
  category: string;
  blurb: string;
  description: string;
  image: string;
  timings: string;
  entryFee: string;
  bestTime: string;
  idealDuration: string;
  address: string;
  highlights: string[];
  featured: boolean;
}

export const touristSpots: TouristSpot[] = [
  // ── South Canara ────────────────────────────────────────────────────────────
  {
    id: "spot-sk-01",
    slug: "panambur-beach",
    name: "Panambur Beach",
    districtSlug: "south-canara",
    districtName: "South Canara",
    category: "Beach",
    blurb: "Popular sunset beach near Mangaluru port, known for water sports.",
    description:
      "One of the best maintained beaches on the Canara coast, Panambur sits right beside the New Mangalore Port. Wide sands, gentle surf and a long promenade make it the city's favourite evening escape, with jet-skiing, boat rides and beach shacks adding to the buzz.",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20sandy%20beach%20at%20golden%20sunset%20with%20gentle%20waves%2C%20coconut%20palms%20along%20the%20shoreline%20and%20distant%20port%20cranes%2C%20warm%20orange%20sky%2C%20coastal%20Karnataka%20travel%20photography&width=1200&height=800&seq=spot-panambur-beach-01&orientation=landscape",
    timings: "Open all day (water sports 9:00 AM – 6:00 PM)",
    entryFee: "Free entry",
    bestTime: "October to February, evenings",
    idealDuration: "2 – 3 hours",
    address: "Panambur, Mangaluru, Dakshina Kannada, Karnataka",
    highlights: ["Sunset views", "Water sports", "Beach shacks", "Kids play area"],
    featured: true,
  },
  {
    id: "spot-sk-02",
    slug: "kadri-manjunath-temple",
    name: "Kadri Manjunath Temple",
    districtSlug: "south-canara",
    districtName: "South Canara",
    category: "Temple",
    blurb: "Ancient hilltop temple famous for its bronze idols and lush gardens.",
    description:
      "Set on Kadri hill, this 10th-century temple is one of Mangaluru's oldest religious sites. It is best known for its exquisite bronze idols and the natural spring that feeds nine tanks, all wrapped in a quiet garden of frangipani and palm.",
    image:
      "https://readdy.ai/api/search-image?query=Ancient%20South%20Indian%20stone%20temple%20with%20tiered%20gopuram%20surrounded%20by%20lush%20green%20gardens%20and%20palm%20trees%2C%20warm%20morning%20light%2C%20serene%20heritage%20architecture%20photography&width=1200&height=800&seq=spot-kadri-temple-01&orientation=landscape",
    timings: "6:00 AM – 1:00 PM, 4:00 PM – 8:00 PM",
    entryFee: "Free entry",
    bestTime: "November to February, early morning",
    idealDuration: "1 – 2 hours",
    address: "Kadri, Mangaluru, Dakshina Kannada, Karnataka",
    highlights: ["Bronze idols", "Hilltop views", "Garden complex", "Natural spring"],
    featured: false,
  },
  {
    id: "spot-sk-03",
    slug: "sultan-battery",
    name: "Sultan Battery",
    districtSlug: "south-canara",
    districtName: "South Canara",
    category: "Heritage",
    blurb: "16th-century riverside watchtower built by Tipu Sultan.",
    description:
      "A squat basalt watchtower built in 1784 on the banks of the Gurupura river. Once used to guard the port from warships, it now offers sweeping views of the river mouth, the busy harbour and the boats that still criss-cross the water.",
    image:
      "https://readdy.ai/api/search-image?query=Old%20stone%20watchtower%20fort%20on%20a%20river%20bank%20with%20views%20of%20boats%20and%20harbour%2C%20dramatic%20evening%20sky%2C%20historic%20coastal%20heritage%20photography&width=1200&height=800&seq=spot-sultan-battery-01&orientation=landscape",
    timings: "9:00 AM – 6:00 PM",
    entryFee: "₹5 per person",
    bestTime: "October to March, late afternoon",
    idealDuration: "1 hour",
    address: "Boloor, Mangaluru, Dakshina Kannada, Karnataka",
    highlights: ["River views", "Historic fort", "Boat watching", "Harbour panorama"],
    featured: false,
  },
  {
    id: "spot-sk-04",
    slug: "st-aloysius-chapel",
    name: "St. Aloysius Chapel",
    districtSlug: "south-canara",
    districtName: "South Canara",
    category: "Heritage",
    blurb: "Historic chapel celebrated across India for its hand-painted frescoes.",
    description:
      "Built in 1880 and tucked inside the St. Aloysius campus, this chapel is often called the Sistine Chapel of the East. Every inch of its walls and ceiling is covered with frescoes painted by Antonio Moscheni, a sight that draws art lovers from around the world.",
    image:
      "https://readdy.ai/api/search-image?query=Ornate%20heritage%20chapel%20interior%20with%20intricately%20painted%20ceiling%20frescoes%20and%20arches%2C%20warm%20soft%20interior%20light%2C%20classical%20religious%20art%20photography&width=1200&height=800&seq=spot-aloysius-chapel-01&orientation=landscape",
    timings: "9:00 AM – 12:30 PM, 2:30 PM – 5:30 PM",
    entryFee: "Free entry",
    bestTime: "Weekday mornings",
    idealDuration: "45 minutes",
    address: "Light House Hill Road, Mangaluru, Dakshina Kannada, Karnataka",
    highlights: ["Moscheni frescoes", "Heritage architecture", "Guided tours", "Photo-worthy interiors"],
    featured: true,
  },
  {
    id: "spot-sk-05",
    slug: "kudroli-gokarnath-temple",
    name: "Kudroli Gokarnath Temple",
    districtSlug: "south-canara",
    districtName: "South Canara",
    category: "Temple",
    blurb: "Grand temple in the heart of Mangaluru, a Dasara landmark.",
    description:
      "A vibrant Shiva temple rebuilt in the 1900s, famous for the nine-day Mangaluru Dasara that lights up the whole city. The ornate gopuram, Ganesh idol and gold-plated sanctum make it one of the most visited temples in the district.",
    image:
      "https://readdy.ai/api/search-image?query=Towering%20South%20Indian%20temple%20gopuram%20richly%20carved%20and%20colourful%2C%20festival%20lights%20and%20flowers%2C%20festive%20evening%20atmosphere%2C%20religious%20architecture%20photography&width=1200&height=800&seq=spot-kudroli-temple-01&orientation=landscape",
    timings: "6:00 AM – 8:30 PM",
    entryFee: "Free entry",
    bestTime: "September to October during Dasara",
    idealDuration: "1 hour",
    address: "Kudroli, Mangaluru, Dakshina Kannada, Karnataka",
    highlights: ["Mangaluru Dasara", "Ornate gopuram", "Festival food stalls", "Central location"],
    featured: false,
  },
  {
    id: "spot-sk-06",
    slug: "tannirbhavi-beach",
    name: "Tannirbhavi Beach",
    districtSlug: "south-canara",
    districtName: "South Canara",
    category: "Beach",
    blurb: "Calm crescent beach reached by ferry across the Gurupura river.",
    description:
      "Reached by a short, scenic ferry ride from Sultan Battery, Tannirbhavi is quieter and cleaner than the city beaches. A tree-lined walkway, sea-view benches and nearby Tannirbhavi Tree Park make it a lovely half-day picnic.",
    image:
      "https://readdy.ai/api/search-image?query=Calm%20curved%20beach%20with%20casuarina%20trees%20and%20a%20wooden%20walkway%20by%20the%20sea%2C%20soft%20afternoon%20light%2C%20peaceful%20coastal%20landscape%20photography&width=1200&height=800&seq=spot-tannirbhavi-beach-01&orientation=landscape",
    timings: "Open all day (ferry 8:00 AM – 6:00 PM)",
    entryFee: "Free entry (small ferry charge)",
    bestTime: "October to February",
    idealDuration: "2 hours",
    address: "Tannirbhavi, Mangaluru, Dakshina Kannada, Karnataka",
    highlights: ["Ferry ride", "Tree park", "Quiet sands", "Sea-view walkway"],
    featured: false,
  },
  {
    id: "spot-sk-07",
    slug: "pilikula-nisargadhama",
    name: "Pilikula Nisargadhama",
    districtSlug: "south-canara",
    districtName: "South Canara",
    category: "Nature",
    blurb: "Sprawling nature park with zoo, lake and heritage village.",
    description:
      "A 370-acre integrated nature park that packs in a biological park, a boating lake, a heritage village, a science centre and a golf course. The perfect day-out for families, and a great way to see Western Ghats flora and fauna up close.",
    image:
      "https://readdy.ai/api/search-image?query=Green%20nature%20park%20with%20a%20calm%20lake%2C%20walking%20trails%20and%20dense%20tropical%20trees%2C%20families%20strolling%20in%20the%20distance%2C%20bright%20daylight%2C%20lush%20landscape%20photography&width=1200&height=800&seq=spot-pilikula-park-01&orientation=landscape",
    timings: "9:00 AM – 5:30 PM (closed Mondays)",
    entryFee: "₹50 onwards, varies by attraction",
    bestTime: "November to February",
    idealDuration: "Half a day",
    address: "Pilikula, Mudushedde, Mangaluru, Dakshina Kannada, Karnataka",
    highlights: ["Biological park", "Boating lake", "Heritage village", "Science centre"],
    featured: true,
  },
  {
    id: "spot-sk-08",
    slug: "kateel-durga-parameshwari-temple",
    name: "Kateel Durga Parameshwari Temple",
    districtSlug: "south-canara",
    districtName: "South Canara",
    category: "Temple",
    blurb: "Riverside temple on an islet, a major pilgrimage stop.",
    description:
      "Perched on a rocky islet in the Nandini river, this temple dedicated to Goddess Durga is one of the most loved pilgrimage spots on the coast. Devotees come for the serene riverside setting, the annual chariot festival and the temple's famed hospitality.",
    image:
      "https://readdy.ai/api/search-image?query=Traditional%20temple%20on%20a%20small%20river%20island%20surrounded%20by%20water%20and%20coconut%20palms%2C%20soft%20golden%20light%2C%20peaceful%20pilgrimage%20site%20photography&width=1200&height=800&seq=spot-kateel-temple-01&orientation=landscape",
    timings: "5:30 AM – 9:00 PM",
    entryFee: "Free entry",
    bestTime: "November to February",
    idealDuration: "1 – 2 hours",
    address: "Kateel, Mangaluru taluk, Dakshina Kannada, Karnataka",
    highlights: ["River islet setting", "Chariot festival", "Prasada meals", "Riverside walk"],
    featured: false,
  },

  // ── Udupi ───────────────────────────────────────────────────────────────────
  {
    id: "spot-ud-01",
    slug: "sri-krishna-temple-udupi",
    name: "Sri Krishna Temple",
    districtSlug: "udupi",
    districtName: "Udupi",
    category: "Temple",
    blurb: "Iconic 13th-century temple and the spiritual heart of Udupi town.",
    description:
      "Founded by Madhvacharya in the 13th century, the Udupi Sri Krishna Temple is one of the most important pilgrimage centres in South India. Devotees view the deity through a silver-plated window called Kanakana Kindi, and the temple's kitchen serves free meals to all.",
    image:
      "https://readdy.ai/api/search-image?query=Grand%20South%20Indian%20temple%20complex%20with%20tall%20gopuram%20and%20temple%20tank%2C%20devotees%20walking%20with%20offerings%2C%20warm%20daylight%2C%20spiritual%20heritage%20photography&width=1200&height=800&seq=spot-udupi-krishna-temple-01&orientation=landscape",
    timings: "4:00 AM – 9:30 PM",
    entryFee: "Free entry",
    bestTime: "October to March",
    idealDuration: "1 – 2 hours",
    address: "Car Street, Udupi, Udupi district, Karnataka",
    highlights: ["Kanakana Kindi", "Free temple meals", "Car Street market", "Evening bhajans"],
    featured: true,
  },
  {
    id: "spot-ud-02",
    slug: "malpe-beach",
    name: "Malpe Beach",
    districtSlug: "udupi",
    districtName: "Udupi",
    category: "Beach",
    blurb: "Bustling beach and fishing harbour, gateway to St. Mary's Island.",
    description:
      "Malpe is Udupi's busiest beach, a working fishing harbour wrapped in a lively holiday strip. Speedboat rides, a long promenade and street food stalls keep it buzzing, while boats from here ferry visitors to the famous St. Mary's Island.",
    image:
      "https://readdy.ai/api/search-image?query=Busy%20coastal%20beach%20with%20colourful%20fishing%20boats%2C%20a%20curving%20promenade%20and%20tourists%20at%20sunset%2C%20warm%20golden%20light%2C%20lively%20seaside%20photography&width=1200&height=800&seq=spot-malpe-beach-01&orientation=landscape",
    timings: "Open all day (boat rides 9:00 AM – 5:00 PM)",
    entryFee: "Free entry (boat charges apply)",
    bestTime: "October to February",
    idealDuration: "2 – 3 hours",
    address: "Malpe, Udupi district, Karnataka",
    highlights: ["Boat rides", "Fishing harbour", "Seaside promenade", "Street food"],
    featured: true,
  },
  {
    id: "spot-ud-03",
    slug: "st-marys-island",
    name: "St. Mary's Island",
    districtSlug: "udupi",
    districtName: "Udupi",
    category: "Island",
    blurb: "Basalt rock formations reached by a short boat ride from Malpe.",
    description:
      "A group of tiny uninhabited islands famous for their distinctive hexagonal basalt columns, formed by volcanic activity millions of years ago. Now a National Geological Monument, it is a short and scenic boat ride from Malpe harbour with crystal-clear shallows.",
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20hexagonal%20basalt%20rock%20columns%20on%20a%20small%20island%20shore%20with%20clear%20turquoise%20water%2C%20bright%20sunny%20day%2C%20unique%20geological%20travel%20photography&width=1200&height=800&seq=spot-st-marys-island-01&orientation=landscape",
    timings: "Boats 9:00 AM – 5:00 PM (weather permitting)",
    entryFee: "Free entry (boat charge ~₹300)",
    bestTime: "October to January, calm mornings",
    idealDuration: "2 – 3 hours",
    address: "Off Malpe coast, Udupi district, Karnataka",
    highlights: ["Basalt columns", "Boat ride", "Clear shallows", "Geological monument"],
    featured: true,
  },
  {
    id: "spot-ud-04",
    slug: "kaup-beach-lighthouse",
    name: "Kaup Beach & Lighthouse",
    districtSlug: "udupi",
    districtName: "Udupi",
    category: "Beach",
    blurb: "Cliffside lighthouse with panoramic views of the coastline.",
    description:
      "Kaup Beach pairs black rocks and rolling surf with a 27-metre lighthouse built in 1901. Climb to the viewing gallery for a wide sweep of the Arabian Sea, then walk down to the rocky shore for tide pools and sunset views.",
    image:
      "https://readdy.ai/api/search-image?query=Tall%20white%20lighthouse%20on%20a%20rocky%20cliff%20above%20the%20sea%20with%20waves%20crashing%20on%20black%20rocks%2C%20dramatic%20late%20afternoon%20light%2C%20coastal%20landmark%20photography&width=1200&height=800&seq=spot-kaup-lighthouse-01&orientation=landscape",
    timings: "Beach all day (lighthouse 4:00 PM – 5:30 PM)",
    entryFee: "Free entry (lighthouse ₹10)",
    bestTime: "October to February",
    idealDuration: "1 – 2 hours",
    address: "Kaup, Udupi district, Karnataka",
    highlights: ["Lighthouse climb", "Panoramic views", "Rocky shoreline", "Sunset spot"],
    featured: false,
  },
  {
    id: "spot-ud-05",
    slug: "kollur-mookambika-temple",
    name: "Kollur Mookambika Temple",
    districtSlug: "udupi",
    districtName: "Udupi",
    category: "Temple",
    blurb: "Famous pilgrimage temple nestled in the Western Ghats foothills.",
    description:
      "One of the seven Mukti Sthalas of Karnataka, the Mookambika Temple draws devotees from across India. Set at the foot of Kodachadri hill beside the Sowparnika river, it is especially busy during Navaratri when thousands arrive for the grand celebrations.",
    image:
      "https://readdy.ai/api/search-image?query=Ancient%20temple%20with%20golden%20gopuram%20set%20against%20green%20forested%20hills%2C%20devotees%20in%20traditional%20attire%2C%20warm%20morning%20light%2C%20spiritual%20travel%20photography&width=1200&height=800&seq=spot-kollur-temple-01&orientation=landscape",
    timings: "5:00 AM – 9:00 PM",
    entryFee: "Free entry",
    bestTime: "October to February, Navaratri",
    idealDuration: "2 hours",
    address: "Kollur, Kundapura taluk, Udupi district, Karnataka",
    highlights: ["Mukti Sthala", "Navaratri festival", "Forest setting", "Temple tank"],
    featured: false,
  },
  {
    id: "spot-ud-06",
    slug: "anejari-betta",
    name: "Anejari Betta",
    districtSlug: "udupi",
    districtName: "Udupi",
    category: "Trek",
    blurb: "Scenic hill trek with ancient shrines and sweeping valley views.",
    description:
      "A beginner-friendly hill trek near Karkala that rewards a short climb with a cluster of old Jain shrines and a panoramic view over the Western Ghats. Best tackled early morning when the mist still clings to the valley below.",
    image:
      "https://readdy.ai/api/search-image?query=Rocky%20hill%20summit%20with%20ancient%20stone%20shrines%20overlooking%20misty%20green%20valley%2C%20early%20morning%20light%2C%20trekking%20landscape%20photography&width=1200&height=800&seq=spot-anejari-betta-01&orientation=landscape",
    timings: "6:00 AM – 6:00 PM",
    entryFee: "Free entry",
    bestTime: "October to February, sunrise",
    idealDuration: "2 – 3 hours",
    address: "Near Karkala, Udupi district, Karnataka",
    highlights: ["Sunrise trek", "Jain shrines", "Valley views", "Photography point"],
    featured: false,
  },
  {
    id: "spot-ud-07",
    slug: "kodi-bengre-beach",
    name: "Kodi Bengre Beach",
    districtSlug: "udupi",
    districtName: "Udupi",
    category: "Beach",
    blurb: "Quiet estuary beach where the river meets the Arabian Sea.",
    description:
      "A peaceful strip at the mouth of the Suvarna river, Kodi Bengre is raw, uncrowded and beautiful. Fishermen bring in their catch at dawn, and the estuary side is perfect for a calm walk away from the crowds.",
    image:
      "https://readdy.ai/api/search-image?query=Serene%20estuary%20meeting%20the%20sea%20with%20small%20fishing%20boats%20and%20sandbanks%2C%20coconut%20trees%20on%20the%20shore%2C%20soft%20morning%20light%2C%20tranquil%20coastal%20photography&width=1200&height=800&seq=spot-kodi-bengre-01&orientation=landscape",
    timings: "Open all day",
    entryFee: "Free entry",
    bestTime: "October to February",
    idealDuration: "1 – 2 hours",
    address: "Kodi Bengre, Hoode, Udupi district, Karnataka",
    highlights: ["Estuary views", "Fishing boats", "Uncrowded sands", "Sunrise walks"],
    featured: false,
  },
  {
    id: "spot-ud-08",
    slug: "jomlu-teertha-falls",
    name: "Jomlu Teertha Falls",
    districtSlug: "udupi",
    districtName: "Udupi",
    category: "Waterfall",
    blurb: "Cool rock pools and small falls, a favourite weekend picnic spot.",
    description:
      "A gentle waterfall and natural rock pool near Hosangadi, reached by a short walk through areca and rubber plantations. The water is refreshingly cool and shallow, making it a relaxed family pick for a hot afternoon.",
    image:
      "https://readdy.ai/api/search-image?query=Small%20waterfall%20cascading%20over%20smooth%20rocks%20into%20a%20clear%20pool%2C%20surrounded%20by%20dense%20tropical%20greenery%2C%20dappled%20sunlight%2C%20nature%20photography&width=1200&height=800&seq=spot-jomlu-teertha-01&orientation=landscape",
    timings: "7:00 AM – 6:00 PM",
    entryFee: "Free entry",
    bestTime: "July to January, after monsoon",
    idealDuration: "2 hours",
    address: "Near Hosangadi, Kundapura taluk, Udupi district, Karnataka",
    highlights: ["Natural pool", "Plantation walk", "Family friendly", "Cool waters"],
    featured: false,
  },

  // ── North Canara ────────────────────────────────────────────────────────────
  {
    id: "spot-nk-01",
    slug: "rabindranath-tagore-beach",
    name: "Rabindranath Tagore Beach",
    districtSlug: "north-canara",
    districtName: "North Canara",
    category: "Beach",
    blurb: "Karwar's main beach with a warship museum and a lively promenade.",
    description:
      "The pride of Karwar, this beach blends soft sand with a seaside promenade, gardens and the INS Chapal warship museum. Evenings bring kite flyers, food carts and families strolling along the water's edge.",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20beach%20with%20a%20stone%20promenade%20and%20gardens%2C%20a%20decommissioned%20warship%20museum%20in%20the%20distance%2C%20warm%20sunset%20light%2C%20coastal%20town%20photography&width=1200&height=800&seq=spot-tagore-beach-01&orientation=landscape",
    timings: "Open all day (museum 9:30 AM – 6:00 PM)",
    entryFee: "Free entry (museum ticket applies)",
    bestTime: "October to February, evenings",
    idealDuration: "2 hours",
    address: "Karwar, Uttara Kannada district, Karnataka",
    highlights: ["Warship museum", "Seaside promenade", "Sunset views", "Food stalls"],
    featured: true,
  },
  {
    id: "spot-nk-02",
    slug: "om-beach-gokarna",
    name: "Om Beach, Gokarna",
    districtSlug: "north-canara",
    districtName: "North Canara",
    category: "Beach",
    blurb: "Om-shaped beach famous for its laid-back coastal vibe.",
    description:
      "One of India's best-known beaches, Om Beach takes its name from its twin-crescent shape that resembles the sacred Om symbol. Rocky headlands, beach cafes and gentle waves make it a favourite for backpackers and sunset chasers.",
    image:
      "https://readdy.ai/api/search-image?query=Scenic%20twin-crescent%20beach%20between%20rocky%20headlands%20with%20golden%20sand%20and%20beach%20shacks%2C%20glowing%20sunset%20sky%2C%20iconic%20travel%20photography&width=1200&height=800&seq=spot-om-beach-01&orientation=landscape",
    timings: "Open all day",
    entryFee: "Free entry",
    bestTime: "November to February",
    idealDuration: "Half a day",
    address: "Gokarna, Uttara Kannada district, Karnataka",
    highlights: ["Om-shaped bay", "Beach cafes", "Sunset views", "Rocky headlands"],
    featured: true,
  },
  {
    id: "spot-nk-03",
    slug: "murudeshwar-temple",
    name: "Murudeshwar Temple",
    districtSlug: "north-canara",
    districtName: "North Canara",
    category: "Temple",
    blurb: "Home to a towering Shiva statue set against the Arabian Sea.",
    description:
      "Murudeshwar is dominated by a 123-foot statue of Lord Shiva, the second tallest in the world, standing on a hill by the sea. A glass lift takes visitors up the 20-storey gopuram for views of the coast, with a scenic beach right below.",
    image:
      "https://readdy.ai/api/search-image?query=Gigantic%20Shiva%20statue%20on%20a%20hill%20beside%20a%20tall%20temple%20tower%20overlooking%20the%20sea%2C%20bright%20blue%20sky%2C%20dramatic%20religious%20landmark%20photography&width=1200&height=800&seq=spot-murudeshwar-temple-01&orientation=landscape",
    timings: "6:00 AM – 8:30 PM",
    entryFee: "Free entry (lift ticket applies)",
    bestTime: "October to February",
    idealDuration: "2 hours",
    address: "Murudeshwar, Bhatkal taluk, Uttara Kannada district, Karnataka",
    highlights: ["Giant Shiva statue", "Gopuram lift", "Sea-view hill", "Nearby beach"],
    featured: true,
  },
  {
    id: "spot-nk-04",
    slug: "yana-caves",
    name: "Yana Caves",
    districtSlug: "north-canara",
    districtName: "North Canara",
    category: "Nature",
    blurb: "Dramatic black limestone rock formations inside a forest reserve.",
    description:
      "Deep inside a forest near Kumta rise two towering black karst outcrops — Bhairaveshwara and Mohini Shikhara. A short trek through the reserve leads to a cave temple, making Yana one of the most striking natural sights in Karnataka.",
    image:
      "https://readdy.ai/api/search-image?query=Towering%20black%20limestone%20rock%20monoliths%20rising%20from%20a%20dense%20green%20forest%2C%20a%20small%20trail%20at%20the%20base%2C%20moody%20natural%20light%2C%20dramatic%20nature%20photography&width=1200&height=800&seq=spot-yana-caves-01&orientation=landscape",
    timings: "6:00 AM – 6:00 PM",
    entryFee: "Free entry",
    bestTime: "October to February",
    idealDuration: "2 – 3 hours",
    address: "Yana, Kumta taluk, Uttara Kannada district, Karnataka",
    highlights: ["Rock monoliths", "Forest trek", "Cave temple", "Photo spot"],
    featured: true,
  },
  {
    id: "spot-nk-05",
    slug: "mirjan-fort",
    name: "Mirjan Fort",
    districtSlug: "north-canara",
    districtName: "North Canara",
    category: "Heritage",
    blurb: "Restored 16th-century fort with mossy walls and watchtowers.",
    description:
      "A beautifully restored laterite fort beside the Aghanashini river, once a strategic trading post. Broad ramparts, bastions and hidden passages now carpeted in green moss make it a photographer's delight and a peaceful history walk.",
    image:
      "https://readdy.ai/api/search-image?query=Old%20laterite%20stone%20fort%20with%20curved%20ramparts%20and%20watchtowers%20covered%20in%20green%20moss%2C%20overcast%20soft%20light%2C%20historic%20ruins%20photography&width=1200&height=800&seq=spot-mirjan-fort-01&orientation=landscape",
    timings: "9:00 AM – 5:30 PM",
    entryFee: "Free entry",
    bestTime: "October to February",
    idealDuration: "1 – 2 hours",
    address: "Mirjan, Kumta taluk, Uttara Kannada district, Karnataka",
    highlights: ["Laterite ramparts", "Mossy walls", "River nearby", "Photo spot"],
    featured: false,
  },
  {
    id: "spot-nk-06",
    slug: "unchalli-falls",
    name: "Unchalli Falls",
    districtSlug: "north-canara",
    districtName: "North Canara",
    category: "Waterfall",
    blurb: "Thundering waterfall reached by a steep forest trail near Sirsi.",
    description:
      "Also called Lushington Falls, Unchalli plunges about 116 metres into a rocky gorge near Sirsi. The viewpoint demands a short but steep descent through forest — the roar and spray at the bottom more than repay the effort, especially after the monsoon.",
    image:
      "https://readdy.ai/api/search-image?query=Powerful%20tall%20waterfall%20plunging%20into%20a%20rocky%20green%20gorge%20surrounded%20by%20dense%20forest%2C%20mist%20rising%2C%20monsoon%20nature%20photography&width=1200&height=800&seq=spot-unchalli-falls-01&orientation=landscape",
    timings: "6:00 AM – 5:00 PM",
    entryFee: "Free entry",
    bestTime: "August to January",
    idealDuration: "2 – 3 hours",
    address: "Near Sirsi, Uttara Kannada district, Karnataka",
    highlights: ["116 m drop", "Forest trail", "Gorge viewpoint", "Monsoon magic"],
    featured: false,
  },
  {
    id: "spot-nk-07",
    slug: "vibhooti-falls",
    name: "Vibhooti Falls",
    districtSlug: "north-canara",
    districtName: "North Canara",
    category: "Waterfall",
    blurb: "Twin-tiered falls with a natural swimming pool below.",
    description:
      "A two-step waterfall on the Yana–Kumta road, Vibhooti is loved for the calm natural pool at its base. A short, easy walk from the parking makes it very accessible, and the surrounding forest keeps it cool even in summer.",
    image:
      "https://readdy.ai/api/search-image?query=Two-tiered%20waterfall%20flowing%20into%20a%20clear%20natural%20swimming%20pool%2C%20surrounded%20by%20rocks%20and%20tropical%20trees%2C%20soft%20daylight%2C%20refreshing%20nature%20photography&width=1200&height=800&seq=spot-vibhooti-falls-01&orientation=landscape",
    timings: "7:00 AM – 6:00 PM",
    entryFee: "Free entry",
    bestTime: "July to January",
    idealDuration: "1 – 2 hours",
    address: "Near Yana, Kumta taluk, Uttara Kannada district, Karnataka",
    highlights: ["Natural pool", "Easy access", "Twin tiers", "Forest setting"],
    featured: false,
  },
  {
    id: "spot-nk-08",
    slug: "syntheri-rocks",
    name: "Syntheri Rocks",
    districtSlug: "north-canara",
    districtName: "North Canara",
    category: "Nature",
    blurb: "Soaring granite monolith surrounded by forest near Yellapur.",
    description:
      "A 300-foot granite monolith rising out of the forest near Yellapur, carved smooth by centuries of rainwater. A short trail from the car park leads to the base, and a nearby stream and cave add to the rugged charm.",
    image:
      "https://readdy.ai/api/search-image?query=Massive%20smooth%20granite%20monolith%20rising%20from%20dense%20green%20forest%20with%20a%20small%20stream%20at%20its%20base%2C%20soft%20daylight%2C%20dramatic%20natural%20landmark%20photography&width=1200&height=800&seq=spot-syntheri-rocks-01&orientation=landscape",
    timings: "7:00 AM – 6:00 PM",
    entryFee: "Free entry",
    bestTime: "October to February",
    idealDuration: "1 – 2 hours",
    address: "Near Yellapur, Uttara Kannada district, Karnataka",
    highlights: ["Granite monolith", "Forest trail", "Nearby stream", "Cave"],
    featured: false,
  },
];